module.exports = __webpack_public_path__ + "static/media/facebook_us.4b068875.png";